import { Button } from '@change/ds-core-ui/next';

import { Translate } from '@change-corgi/core/react/i18n';

export const SubmitButton: React.FC = () => {
	return (
		<Button
			variant="primary"
			size="small"
			type="submit"
			data-qa="report-abuse-submit-button"
			className="sm:w-full lg:w-[120px]"
		>
			<Translate value="corgi.policy_abuse.generic.form_submit" />
		</Button>
	);
};
